import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { connectFreeeForAccounting } from '@src/api'
import {
  ConnectFreeeForAccounting403Response,
  DefaultApiConnectFreeeForAccountingRequest,
} from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useConnectFreeeForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    AxiosResponse,
    AxiosResponse<ConnectFreeeForAccounting403Response>,
    DefaultApiConnectFreeeForAccountingRequest
  >({
    mutationFn: (params: DefaultApiConnectFreeeForAccountingRequest) =>
      connectFreeeForAccounting(axiosInstance, params),
  })
}
